import {
  Divider,
  Skeleton,
  Stack,
  SvgIconProps,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import { addMonths, format, startOfDay, startOfMonth } from 'date-fns';

interface Props {
  icon: React.FC<SvgIconProps>;
  label: string;
  remaining: number;
  total: number;
  isLoading?: boolean;
  surplus?: number;
}

function MarketingCreditsItem({
  icon: Icon,
  label,
  remaining,
  total,
  surplus,
  isLoading,
}: Props) {
  const theme = useTheme();
  const nextMonthFirstDay = startOfDay(startOfMonth(addMonths(new Date(), 1)));
  const textColor = theme.palette.darkGrey.main;

  return (
    <Tooltip
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -5],
              },
            },
          ],
        },
      }}
      arrow
      title={
        isLoading
          ? ''
          : `You have ${remaining} ${label} credits remaining out of ${total}. Your credits will reset on ${format(
              nextMonthFirstDay,
              'MMMM d, yyyy',
            )}.${
              surplus
                ? ` You have a credit surplus of ${surplus} that will be carried over to the next month in addition to your monthly credits.`
                : ''
            }`
      }
      placement="top">
      <Stack
        color={textColor}
        direction="row"
        alignItems="center"
        gap={0.5}
        borderRadius="4px"
        bgcolor={theme.palette.lightGrey.main}
        p={1}>
        <Icon
          htmlColor="inherit"
          sx={{
            fontSize: 12,
          }}
        />
        <Typography variant="h4" component="p" color="inherit">
          {label}
        </Typography>
        <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />
        {!isLoading && (
          <Typography
            variant="body2"
            color="inherit">{`${remaining} of ${total}`}</Typography>
        )}
        {isLoading && (
          <Skeleton
            variant="text"
            width={75}
            height={14}
            sx={{ borderRadius: '4px' }}
          />
        )}
      </Stack>
    </Tooltip>
  );
}

export default MarketingCreditsItem;
